var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"label":_vm.label,"items":_vm.attachments,"item-value":"id","item-text":"name","loading":_vm.loading},on:{"input":_vm.handleInput}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }